<div class="common-container" [ngClass]="{ 'common-container--color-settings': colorSettingsMode }">
  <div class="bm--footer" [ngClass]="{ 'bm--footer--open-player': !!player.currentTrack }">
    <!-- Logotype -->
    <div class="bm--footer__logo-block">
      <div class="bm--footer__logo theme-footer__logo" routerLink="/">
        @if (footerLogoUrl) {
          <img class="bm--footer__logo--img" src="{{ footerLogoUrl }}" alt="logotype" />
        }
        @if (!footerLogoUrl) {
          <p class="bm--footer__producer-name">{{ beatmakerName }}</p>
        }
      </div>
      <p class="bm--footer__text theme-footer__info">{{ lg.footer.getDescription(currentYear) }}</p>
    </div>

    <div class="bm--footer__container">
      <div class="bm--footer__links-box">
        <h3 class="bm--footer__title theme-footer__linkGroupTitle">{{ lg.footer.pages }}</h3>
        <bmcore-footer-menu-links [links]="routes | slice: 0 : 2"></bmcore-footer-menu-links>
      </div>

      <div class="bm--footer__links-box">
        <h3 class="bm--footer__title theme-footer__linkGroupTitle">{{ lg.footer.info }}</h3>
        <bmcore-footer-menu-links [links]="routes | slice: 2 : 4"></bmcore-footer-menu-links>
      </div>

      <!-- Language select -->
      <div class="footer__lang-select">
        <bmcore-lang-select></bmcore-lang-select>
      </div>
    </div>
  </div>
</div>
